<script>
import { useImage, useLink } from '@/helpers/url'

export default {

    methods: {

        image: img => useImage(img),   

        link: url => useLink(url)         
    }
}

</script>
 